// Human labels for the machine-key capability taxonomy the server
// exposes via /api/agents/capabilities. Kept as a plain map so
// dropping in a new key requires exactly one edit here to render.
// Missing entries fall back to the machine key itself.

export const AGENT_CAPABILITY_LABELS: Record<string, string> = {
  ai: 'AI / ML',
  code: 'Code',
  writing: 'Writing',
  translation: 'Translation',
  image: 'Image',
  video: 'Video',
  audio: 'Audio',
  research: 'Research',
  'data-analysis': 'Data analysis',
  financial: 'Financial',
  gaming: 'Gaming',
  'customer-support': 'Customer support',
  legal: 'Legal',
  medical: 'Medical',
  education: 'Education',
  'personal-assistant': 'Personal assistant',
  other: 'Other',
};

export function labelForCapability(key: string): string {
  return AGENT_CAPABILITY_LABELS[key] ?? key;
}
